import React from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react'

import defaultTheme from './assets/style/defaultTheme';

import App from './App';
import SiteHeader from './Container/SiteHeader';
import SiteFooter from './Container/SiteFooter';
import reportWebVitals from './reportWebVitals';

type InitDataType = {
  slug: string;
  type: string;
  query: string;
};

const bodyDom:any = document.getElementById('shereact-body');

function parseQS(location:any) {
  const { pathname, search } = location;
  let qsArray = pathname.replace(/^\/|\/$/g, '').split('/');
  const keys = ['slug', 'first', 'second', 'third', 'fourth'];
  let qsOutput = '';
  qsArray.map((item:string, index:number) => {
    qsOutput += `${keys[index]}=${item}&`;
  });

  if (search !== '') {
    qsOutput+= search.replace('?', '');
  }
  
  return qsOutput;
}

const theme = extendTheme(defaultTheme);

if (bodyDom) {
  const data:any = bodyDom.dataset.component;

  const initialPageProps:InitDataType = {
    type: 'page',
    slug: window.location.pathname === '/' ? 'home' : window.location.pathname.replace(/^\/|\/$/g, '').split('/')[0],
    query: parseQS(window.location),
  }

  const pageProps:InitDataType = data === undefined ? initialPageProps : JSON.parse(data);

  ReactDOM.render(
    // <React.StrictMode>
      <ChakraProvider theme={theme}>
      <App {...pageProps} />
      </ChakraProvider>
    // </React.StrictMode>,
    ,bodyDom
  );
}

const siteHeaderDom = document.getElementById('shereact-siteheader');

if (siteHeaderDom) {
  ReactDOM.render(
    // <React.StrictMode>
      <SiteHeader />
    // </React.StrictMode>,
    ,siteHeaderDom
  );
}

const siteFooterDom = document.getElementById('shereact-sitefooter');

if (siteFooterDom) {
  ReactDOM.render(
    // <React.StrictMode>
      <SiteFooter />
    // </React.StrictMode>,
    ,siteFooterDom
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
